import { useState, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import Style from './css/style.module.css';
import SupplyListArea from "./area/supply_list";

function SendPaytBySupplyArea(props: any) {
  let myProps = {
    supply_seq_arr: [],
    refresh_data: (inData: any) => { },
    is_show_close: true,
    close_text: "닫기",
    close: () => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  let now_ymd = DateFunc.get_date_format(new Date(), "Ymd");
  let now_y_m_d = DateFunc.get_date_format(new Date(), "Y-m-d");
  let [supply_info_arr, set_supply_info_arr] = useState<any>([]);

  useEffect(() => {
    get_supply_arr_by_ajax({ supply_seq_arr: myProps.supply_seq_arr });
  }, []);

  const get_supply_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      supply_seq_arr: [],
      ...inData
    };
    if (strFunc.is_empty(opt_obj.supply_seq_arr)) {
      //alert("학생 키가 없습니다.");
      return false;
    }
    let form_json_data = {
      "s_pri_arr": opt_obj.supply_seq_arr,
      s_addon_user: "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_supply_info_arr(response.data["data"]["info_arr"]);
        } else {
          set_supply_info_arr([]);
        }
      });
  };

  const go_add_payt_by_ajax = () => {
    if (supply_info_arr.length == 0) {
      alert("청구서를 선택해주세요.");
      return false;
    }
    
    if (confirm("청구서를 전송 하시겠습니까?") == false) {
      return false;
    }
    let supply_seq_arr = [];
    let receiv_phone_num_arr:any=[];
    for (let i = 0; i < supply_info_arr.length; i++) {
      let supply_info = supply_info_arr[i];
      let row_pri_val=supply_info["row_pri_val"];
      supply_seq_arr.push(row_pri_val);
      if(supply_info["receiv_phone"]&&supply_info["receiv_phone"]["phone_num"]){
        receiv_phone_num_arr.push({
          supply_seq:row_pri_val,
          ...supply_info["receiv_phone"],
        });
      }
    }
    
    let form_json_data = {
      "supply_seq_arr": supply_seq_arr,
      "receiv_phone_num_arr":receiv_phone_num_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/class_supply/send_payt', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert(response.data["msg"]);
          myProps.refresh_data({});
          myProps.close();
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  return (
    <div className={Style.popup_wrap}>
      <div>
        <SupplyListArea
          supply_info_arr={supply_info_arr}
          set_supply_info_arr={set_supply_info_arr}
        ></SupplyListArea>
      </div>
      <div className="text-center mt-1">
        <button className="btn btn-sky" onClick={() => { go_add_payt_by_ajax(); }}>청구서 전송</button>
        {myProps.is_show_close &&
          <button className="btn btn-dark ml-1" onClick={() => { myProps.close(); }} >{myProps.close_text}</button>
        }
      </div>
    </div>
  );
};
export default SendPaytBySupplyArea;